export function maskCardNumber(value: undefined | null | string | number): string {
  const lastFour = `${value || ""}`.substr(-4).padStart(4, "*");
  return `**** **** **** ${lastFour}`;
}
